import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HelpDocsJwtControllerService,
  HelpDocsJwtResponseDTO
} from '@libs/api';

@Injectable({
  providedIn: 'root'
})
export class HelpDocsJwtService {
  private readonly helpDocsApi = inject(HelpDocsJwtControllerService);

  constructor() {
    this.helpDocsApi.configuration.withCredentials = true;
  }

  /**
   * Calls API to generate HelpDocs JWT and set cookie via Set-Cookie header
   */
  setHelpDocsJwt(): Observable<HelpDocsJwtResponseDTO> {
    return this.helpDocsApi.helpDocsJwtControllerGenerateHelpDocsJwt();
  }

  /**
   * Clear HelpDocs JWT cookie (for logout)
   * Uses backend endpoint since cookie is HttpOnly and cannot be cleared via JavaScript
   */
  clearHelpDocsJwt(): Observable<HelpDocsJwtResponseDTO> {
    return this.helpDocsApi.helpDocsJwtControllerGenerateHelpDocsJwt({
      clear: true
    });
  }
}
